import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestUpdateSubChildCategory } from "./updateSubChildCategory.request";

const useUpdateSubChildCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateSubChildCategory,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateSubChildCategory;
